document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("addEngraving");
  const textareaWrapper = document.getElementById("engravingForm");
  if (!checkbox || !textareaWrapper) {
    return;
  }
  const textarea = textareaWrapper.querySelector("#engravingText");
  const charCount = textareaWrapper.querySelector("#charCount");
  const errorMsg = textareaWrapper.querySelector("#engravingError");
  checkbox.addEventListener("change", function () {
    if (this.checked) {
      textareaWrapper.classList.add("open");
    } else {
      textareaWrapper.classList.remove("open");
    }
  });

  textarea.addEventListener("input", function () {
    errorMsg.classList.remove("visible");
    charCount.textContent = this.value.length;
    if (this.value.length <= 30) {
      return;
    }
    errorMsg.classList.toggle("visible", true);
  });
});

function getAllItemsForCart(mainProductFormData) {
  const productObj = formDataToObject(mainProductFormData);
  const textarea = document.getElementById("engravingText");
  const { id, properties, quantity, ...whatsLeft } = productObj;
  const cartItems = {
    items: [],
  };
  const addEngraving = document.getElementById("addEngraving")?.checked;
  const giftWrap = document.querySelector(".boa-gift-wrapping");
  const addWrapInput = giftWrap?.querySelector("input#giftWrap");
  if (!addEngraving && !addWrapInput?.checked) {
    return mainProductFormData;
  }

  if (addWrapInput?.checked && giftWrap?.dataset?.productWrappingVariantId) {
    cartItems.items.push({
      id: giftWrap.dataset.productWrappingVariantId,
      quantity: 1,
      properties: {
        _related_sku: giftWrap.dataset.relatedSku,
      },
    });
  }

  const engravingText = textarea?.value?.trim();
  if (addEngraving && engravingText) {
    cartItems.items.push({
      id: textarea.dataset.variantId,
      quantity: 1,
      properties: {
        engraving_text: engravingText,
        _original_text: engravingText,
        _related_sku: textarea.dataset.relatedSku,
      },
    });
    cleanEngravingBlock(textarea);
  }

  cartItems.items.push({
    id,
    properties: properties || {},
    quantity,
  });
  const mainItem = cartItems.items[cartItems.items.length - 1];
  if (addEngraving && engravingText) {
    mainItem.properties["_product_engraving_text"] = engravingText;
  }
  if (addWrapInput?.checked && giftWrap?.dataset?.productWrappingVariantId) {
    mainItem.properties["_product_wrapping"] = true;
    addWrapInput.checked = false;
  }
  return {
    url: "/cart/add.js",
    data: cartItems,
    headers: { "Content-Type": "application/json" },
  };
}

function cleanEngravingBlock(textarea) {
  textarea.value = "";
  document.getElementById("addEngraving").checked = false;
  document.getElementById("engravingForm")?.classList.remove("open");
}

function formDataToObject(formData) {
  const obj = {};

  formData.forEach((value, key) => {
    const keys = key.split(/\[|\]\[?|\]/).filter(Boolean);
    let current = obj;

    while (keys.length > 1) {
      const nextKey = keys.shift();
      current[nextKey] = current[nextKey] || (isNaN(keys[0]) ? {} : []);
      current = current[nextKey];
    }

    // Convert to number if it's an array index
    const finalKey = isNaN(keys[0]) ? keys[0] : Number(keys[0]);

    // Handle JSON-parsed values (useful if the original object was JSON.stringify-ed)
    if (
      typeof value === "string" &&
      value.startsWith("{") &&
      value.endsWith("}")
    ) {
      try {
        value = JSON.parse(value);
      } catch (e) {}
    }

    // Assign final value
    current[finalKey] = value;
  });

  return obj;
}
